import { css } from "styled-components";

export const focusColor = "#288FF0"; // also called colors.functional.secondary.parrot

export const transparentBg = css`
    background-image: url("data:image/png;base64,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");
`;

export const focusBorder = css`
    border: 3px solid ${focusColor};
`;

const colors = {
    primary: {
        pigeon: "#CBCBD2",
        vapor: "#D2D2DA",
        scheifer: "#D8D8DF",
        moon: "#DDDDE3",
        salt: "#E3E3E8",
        whisker: "#E9E9ED",
        igloo: "#EEEEF1",
        diamond: "#F4F4F6",
        plaster: "#F9F9FA",
        snow: "#FFFFFF"
    },
    secondary: {
        onyx: "#000000",
        vampire: "#040407",
        carbon: "#06080D",
        anvil: "#0B0E16",
        stallion: "#0E111B",
        cosmic: "#121520",
        orca: "#141824",
        oolong: "#373B45",
        basalt: "#575861",
        bushrock: "#6D6F75",
        slate: "#77797F",
        sword: "#82848A",
        castle: "#86888E",
        novemberRain: "#8A8C92",
        manatee: "#96979C",
        aluminum: "#9C9DA2",
        chalice: "#A8AAAE",
        dolphin: "#ADAFB3",
        tinfoil: "#B8B9BD",
        shark: "#C2C3C9"
    },
    accent: {
        lightMode: {
            navy: "#042995",
            persian: "#0533B8",
            bluebonnet: "#063DDA",
            blueberry: "#0C49F8",
            bay: "#2F63F9",
            pansy: "#527DFA",
            kewl: "#7497FB",
            smalt: "#97B1FC",
            lupine: "#BACBFD",
            dewdrop: "#DCE5FE"
        },
        darkMode: {
            apollo: "#15346F",
            floridaWater: "#1B428D",
            holland: "#2150AB",
            martianSkies: "#275EC9",
            riviera: "#3A70D9",
            kazoo: "#5886DF",
            stardust: "#769CE5",
            suenosBuenos: "#94B2EB",
            rain: "#B2C7F1",
            surf: "#D0DDF6"
        }
    },
    alternative: {
        lightMode: {
            pine: "#1A410C",
            basil: "#265F12",
            kush: "#327C17",
            shamrock: "#3E9A1D",
            pear: "#4AB823",
            malachite: "#56D629",
            frog: "#6DDC46",
            pothos: "#85E265",
            chartreuse: "#9CE781",
            amak: "#B5EDA1",
            rust: "#841F01",
            mehndi: "#A72701",
            magma: "#CB3001",
            poppy: "#EE3801",
            cameo: "#FE4B15",
            sunset: "#FE6739",
            tang: "#FE825D",
            cantaloupe: "#FE9D80",
            conch: "#FFB9A4",
            shrimpCocktail: "#FFD4C7"
        },
        darkMode: {
            seaweed: "#263F12",
            juniper: "#365B1A",
            moss: "#477722",
            palm: "#57922A",
            leprechaun: "#68AE32",
            edamame: "#78C73D",
            guyabano: "#8CCF59",
            pistachio: "#9FD774",
            aloe: "#B2E090",
            matchaLatte: "#C4E7AA",
            cinnamon: "#8B2704",
            icedTea: "#AD3005",
            annato: "#D03A06",
            jamaica: "#F34407",
            starfish: "#F95B24",
            adobe: "#FA7547",
            reef: "#FB8F6A",
            nutmeg: "#FCA98D",
            canyon: "#FDC2AE",
            guava: "#FEDDD2"
        }
    },
    functional: {
        lightMode: {
            sangria: "#970202",
            arancio: "#BA0303",
            firecracker: "#DE0303",
            laser: "#FC0A0A",
            tomato: "#FC2B2B",
            gladiola: "#FD4F4F",
            watermelon: "#FD7373",
            bouquet: "#FD9595",
            cottonCandy: "#FEB9B9",
            paris: "#FEDCDC"
        },
        darkMode: {
            cardinal: "#9B0D0D",
            flamenco: "#BC1010",
            luftBalloon: "#DC1313",
            tandoori: "#EC2525",
            campfire: "#EF4848",
            sherbet: "#F26969",
            galah: "#F58A8A",
            desertBloom: "#F8AAAA",
            marshmallow: "#FBCBCB",
            himalayan: "#FEECEC"
        },
        secondary: {
            parrot: focusColor,
            slime: "#56D629",
            lingo: "#FF6161",
            tulle: "rgba(255,255,255,0.04)"
        }
    }
};

export default colors;
